import React, { useEffect } from 'react';
import { Box } from '@spothero/ui';
import { getWindow } from 'ssr-window';
import { useGoogleMapsLibraries } from 'common/google-map-context/GoogleMapContext';
const window = getWindow();
const SpotDetailsMap = (props) => {
    const mapRef = React.useRef(null);
    const googleMapRef = React.useRef(null);
    const { googleMapsLoaded, googleMapsLibraries } = useGoogleMapsLibraries();
    useEffect(() => {
        if (googleMapRef.current === null && googleMapsLoaded) {
            const { isDraggable, disableDefaultUI, spotLatitude, spotLongitude, } = props;
            const spotLatLng = { lat: spotLatitude, lng: spotLongitude };
            const mapOptions = {
                zoom: 16,
                center: spotLatLng,
                mapTypeId: googleMapsLibraries.maps.MapTypeId.ROADMAP,
                gestureHandling: isDraggable ? 'auto' : 'none',
                keyboardShortcuts: isDraggable,
                clickableIcons: false,
            };
            if (disableDefaultUI) {
                mapOptions.disableDefaultUI = true;
            }
            else {
                mapOptions.mapTypeControl = false;
                mapOptions.fullscreenControl = false;
            }
            googleMapRef.current = new googleMapsLibraries.maps.Map(mapRef.current, mapOptions);
            // eslint-disable-next-line no-new
            new googleMapsLibraries.marker.Marker({
                map: googleMapRef.current,
                position: spotLatLng,
            });
        }
        return () => {
            if (googleMapRef.current) {
                google.maps.event.clearInstanceListeners(googleMapRef.current);
            }
        };
    }, [props, googleMapsLoaded, googleMapsLibraries]);
    if (typeof window === 'undefined' || !googleMapsLoaded) {
        return null;
    }
    return (<Box height={48} width="100%" overflow="hidden">
            <Box ref={mapRef} position="relative" overflow="hidden" width="100%" height="100%"/>
        </Box>);
};
export default SpotDetailsMap;
